module.exports = __webpack_public_path__ + "img/四川天府新区启元幼儿园.d5f56da1.jpg";